import styled from "styled-components";

const Container = styled.div`
  max-width: 1348px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
`

export default Container
